import DeleteButton from "@components/buttons/DeleteButton";
import EditButton from "@components/buttons/EditButton";
import OutlinedStatus from "@components/status/OutlinedStatus";
import { TNews } from "@type-defs/cms/TNews";

export const newsColumns = (
  editHandler: (id: number | string) => void,
  deleteHandler: (id: number | string) => void,
  canEdit: boolean,
  canDelete: boolean
) => [
  {
    name: "Image",
    cell: (row: TNews) => {
      const imageSrc = row.image_url || row.image || row.cover_image || "";

      return imageSrc ? (
        <div>
          <img
            src={imageSrc}
            alt={row.title}
            style={{
              width: "72px",
              height: "72px",
              objectFit: "cover",
              borderRadius: "8px",
            }}
            onError={(event) => {
              const target = event.currentTarget;
              target.style.display = "none";
              const fallback = target.nextElementSibling as HTMLDivElement | null;
              if (fallback) {
                fallback.style.display = "block";
              }
            }}
          />
          <div className="text-sm text-gray-400" style={{ display: "none" }}>
            Image unavailable
          </div>
        </div>
      ) : (
        <div className="text-sm text-gray-400">No Image</div>
      );
    },
    grow: 0.5,
  },
  {
    name: "Title",
    selector: (row: TNews) => row.title,
    grow: 1.2,
  },
  {
    name: "Date Range",
    selector: (row: TNews) => {
      const fromDate = row.from_date || "-";
      const toDate = row.to_date || "-";

      return (
        <div className="text-sm">
          <div>{fromDate}</div>
          <div>{toDate}</div>
        </div>
      );
    },
    grow: 0.8,
  },
  {
    name: "Status",
    selector: (row: TNews) => (
      <OutlinedStatus
        width="w-[10ch]"
        color={String(row.status) === "1" ? "green" : "red"}
        title={String(row.status) === "1" ? "Active" : "InActive"}
      />
    ),
    grow: 0.6,
  },
  {
    name: "Action",
    right: "true",
    selector: (row: TNews) => (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {canEdit ? (
          <EditButton
            id={row.news_id || ""}
            actionHandler={() => editHandler(row.news_id || "")}
          />
        ) : null}

        {canDelete ? (
          <DeleteButton
            id={row.news_id || ""}
            actionHandler={() => deleteHandler(row.news_id || "")}
          />
        ) : null}
      </div>
    ),
  },
];

export const newsColumnNames = [
  "Image",
  "Title",
  "Date Range",
  "Status",
  "Action",
];
